export const REACT_APP_DYNAMIC_SWAP_URL = process.env.REACT_APP_DYNAMIC_SWAP_URL
export const REACT_APP_REIMBURSEMENT_STAKING_PAGE_URL = process.env.REACT_APP_REIMBURSEMENT_STAKING_PAGE_URL
export const REACT_APP_TVL_SOCKET_SERVER_URL = process.env.REACT_APP_TVL_SOCKET_SERVER_URL
